"use client";

import Plus from "@/assets/svg/32/Plus";
import { ProductCard } from "@/components/molecules/ProductCard/ProductCard";
import {
	autoPlacement,
	offset,
	safePolygon,
	shift,
	useFloating,
	useFocus,
	useHover,
	useInteractions,
} from "@floating-ui/react";
import { ProductCard as ProductCardType } from "@raumagarn/formatters";
import clsx from "clsx";
import { type PropsWithChildren, useState } from "react";
import styles from "./tagged-image.module.css";

const ClientTag = ({
	product,
}: PropsWithChildren<{
	product: Omit<ProductCardType, "relatedProducts" | "variants">;
}>) => {
	const [open, setOpen] = useState(false);

	const { refs, floatingStyles, context } = useFloating({
		open,
		onOpenChange: setOpen,
		strategy: "absolute",
		middleware: [
			offset(5),
			shift(),
			autoPlacement((state) => {
				return {
					rootBoundary: "document",
					elementContext: "reference",
					padding: {
						top: state.rects.floating.height / 2,
						bottom: state.rects.floating.height / 2,
					},

					allowedPlacements: ["bottom", "top"],
				};
			}),
		],
	});

	const focus = useFocus(context);

	const hover = useHover(context, {
		handleClose: safePolygon(),
	});

	const { getReferenceProps, getFloatingProps } = useInteractions([
		hover,
		focus,
	]);

	return (
		<>
			<button
				ref={refs.setReference}
				data-product={product?.id}
				className={clsx(styles.tag__client, open && styles.active)}
				{...getReferenceProps()}
			>
				<Plus />
			</button>
			{open && (
				<div
					className={styles.tagCardContent}
					ref={refs.setFloating}
					style={floatingStyles}
					{...getFloatingProps({ tabIndex: 1 })}
				>
					<ProductCard productCard={product} />
				</div>
			)}
		</>
	);
};

export default ClientTag;
